export class SparkJob {
    'id';
    'name';
    'sparkEngineId';
    'status';
    'createdAt';
    'jobTimeout';
    'retryPolicy';
    'sparkSubmitParams';
    'storageConfig';
    'sparkApplicationId';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "sparkEngineId",
            "baseName": "sparkEngineId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "SparkJobStatus",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "jobTimeout",
            "baseName": "jobTimeout",
            "type": "number",
            "format": ""
        },
        {
            "name": "retryPolicy",
            "baseName": "retryPolicy",
            "type": "SparkJobRetryPolicy",
            "format": ""
        },
        {
            "name": "sparkSubmitParams",
            "baseName": "sparkSubmitParams",
            "type": "SparkJobSparkSubmitParams",
            "format": ""
        },
        {
            "name": "storageConfig",
            "baseName": "storageConfig",
            "type": "StorageConfig",
            "format": ""
        },
        {
            "name": "sparkApplicationId",
            "baseName": "sparkApplicationId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SparkJob.attributeTypeMap;
    }
    constructor() {
    }
}
